// @flow

const map = {
  'App Name': 'eQon',
  'App Link': 'https://tufacturero.ec/',
  'Support text': 'Buenas, mi nombre es {{name}}, necesito ayuda con eQon.',
  'Agent support text': 'Buenas, mi nombre es {{name}}, necesito ayuda con eQon.',
};

export const resources = {
  es: {
    translation: map,
  },
};
